<template>
	<div class="white pos-rel rounded-lg min-h-screen">
		<div class="header">
			<v-btn fab flat @click="closeModal">
				<v-icon>close</v-icon>
			</v-btn>

			<div>Creator Info</div>
			<v-btn fab flat icon @click="downLoadHostPerformance">
				<v-icon>download</v-icon>
			</v-btn>
		</div>

		<v-card class="pa-3 ma-2">
			<v-layout
				v-if="Object.keys(creatorDetails).length > 0"
				class="d-flex flex-column justify-center align-center"
			>
				<v-avatar color="#A3AED0" size="80px">
					<img v-bind:src="creatorDetails.pic" alt="profilepic" />
				</v-avatar>
				<p class="mt-3">
					<span class="font-weight-bold">Name:</span>
					{{ creatorDetails.name }}
				</p>
				<p>
					<span class="font-weight-bold">Handle:</span>
					@{{ creatorDetails.handle }}
				</p>
				<p>
					<span class="font-weight-bold">Onboarded Date:</span>
					{{ creatorDetails.onboardingDate }}
				</p>
				<p v-if="creatorDetails.lastLiveDate">
					<span class="font-weight-bold">Last Live Time:</span>
					{{
						convertToReadableDate(creatorDetails.lastLiveDate) +
							" (" +
							creatorDetails.lastLiveDuration +
							")"
					}}
				</p>
			</v-layout>
			<v-layout>
				<v-flex>
					<p class="refreshText">Data refreshes at 4AM daily</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex class="mt-3">
					<v-data-table
						:headers="tableHeaders"
						:items="allInvites"
						:loading="isGetInviteLoading"
						hide-actions
						disable-initial-sort
					>
						<template v-slot:headers="props">
							<tr>
								<th
									v-for="header in props.headers"
									:key="header.text"
									class="text-left headerText"
								>
									{{ header.text }}
									<v-tooltip
										v-if="header.value === 'liveDays'"
										bottom
									>
										<template v-slot:activator="{ on }">
											<v-icon
												size="18"
												color="black"
												dark
												v-on="on"
												>info_outline</v-icon
											>
										</template>
										<span
											>Live Day is counted only if the
											host went live for at least 15 mins
											that day</span
										>
									</v-tooltip>
								</th>
							</tr>
						</template>
						<template v-slot:items="props">
							<td>
								{{ props.item.month || "NA" }}
							</td>
							<td>
								{{ props.item.rank || "NA" }}
							</td>
							<td>
								{{ Math.round(props.item.mintsEarned) || "NA" }}
							</td>
							<td>
								{{ props.item.liveDays || "NA" }}
							</td>
						</template>
					</v-data-table>
				</v-flex>
			</v-layout>
			<div v-if="!isGetInviteLoading && allInvites.length > 0">
				<custom-table-footer
					:goBackward="goBackward"
					:goForward="goForward"
					:onRowNumberChange="onRowNumberChange"
					:offset="offset"
					:nextOffset="nextOffset"
					:totalFetchedRows="allInvites.length"
					:totalEntries="totalEntries"
					:selectedRows="rowNumbers"
				/>
			</div>
		</v-card>
	</div>
</template>

<script>
import { SHOW_ALERT } from "@/store/action-types";
import ApiService from "@/store/api-service";
import { MOJ_TOOLS_BASE_URL, MOJ_TOOLS_ACCESS_TOKEN } from "../../../config";
import CustomTableFooter from "./custom-table-footer.vue";
import { getCsvRows, downloadArrayAsCsv } from "../../utils";

export default {
	name: "InvitationTable",
	props: ["model", "agencyId", "creatorId"],
	data() {
		return {
			creatorDetails: {},
			allInvites: [],
			headers: [
				{
					text: "Month",
					value: "month",
					align: "left",
					sortable: true
				},
				{
					text: "Rank",
					value: "rank",
					align: "left",
					sortable: false
				},
				{
					text: "Mints Earned",
					value: "mintsEarned",
					align: "left",
					sortable: false
				},
				{
					text: "Live Days",
					align: "left",
					value: "liveDays",
					sortable: false
				}
			],
			isGetInviteLoading: true,
			offset: 0,
			nextOffset: 0,
			totalEntries: null,
			bulkDownload: false,
			rowNumbers: 10,
			creatorCsvHeaders: {
				HostId: "creatorId",
				HostHandle: "handle",
				HostName: "name",
				RankInAgency: "rank",
				Month: "month",
				Mints: "mintsEarned",
				LiveDays: "liveDays"
			},
			keysToRound: ["mintsEarned"]
		};
	},

	mounted() {
		this.fetchTableData();
	},
	components: {
		"custom-table-footer": CustomTableFooter
	},
	computed: {
		isSmallScreen() {
			let screen_size = this.$vuetify.breakpoint.name;
			return screen_size === "xs" || screen_size === "sm";
		},
		tableHeaders() {
			let headers = this.headers;
			return headers;
		}
	},
	methods: {
		convertToReadableDate(dateStr) {
			const date = new Date(dateStr);
			const formattedDate = date.toLocaleDateString("en-GB", {
				day: "2-digit",
				month: "short",
				year: "numeric"
			});
			return formattedDate;
		},

		closeModal() {
			this.$emit("CLOSE_CREATOR_MODAL", this.model);
		},

		downLoadHostPerformance() {
			this.bulkDownload = true;
			this.fetchTableData();
		},

		downloadReport(hostData) {
			const headers = Object.keys(this.creatorCsvHeaders);
			const updatedHostData = hostData.map(entry => {
				return {
					...entry,
					creatorId: this.creatorId,
					handle: this.creatorDetails.handle,
					name: this.creatorDetails.name
				};
			});
			const dataToDownload = getCsvRows(
				updatedHostData,
				this.creatorCsvHeaders,
				this.keysToRound
			);
			const date = new Date()
				.toISOString()
				.split("T")[0]
				.replace(/-/g, "");
			downloadArrayAsCsv(
				[[headers], ...dataToDownload],
				`Host Performance Report - ${this.creatorDetails.handle} - ${date}`
			);
		},

		goForward() {
			this.offset = this.nextOffset;
			this.fetchTableData();
		},
		goBackward() {
			this.offset = Math.max(0, this.offset - this.rowNumbers);
			this.fetchTableData();
		},
		onRowNumberChange(rowCount) {
			this.rowNumbers = rowCount;
			this.fetchTableData();
		},

		async fetchTableData() {
			this.isGetInviteLoading = true;

			const headers = {
				"X-SHARECHAT-ACCESS-TOKEN": MOJ_TOOLS_ACCESS_TOKEN
			};

			try {
				let endpoint = `${MOJ_TOOLS_BASE_URL}/livestream-tools-service/v1/public/agencies/${this.agencyId}/creators/${this.creatorId}?offset=${this.offset}&rowsPerPage=${this.rowNumbers}`;
				if (this.bulkDownload)
					endpoint += `&bulkDownload=${this.bulkDownload}`;
				const response = await ApiService.get(endpoint, headers);
				const { userDetails, data, offset, totalRows } = response;
				if (this.bulkDownload) {
					this.bulkDownload = false;
					this.downloadReport(data);
				} else {
					this.allInvites = data;
					this.nextOffset = offset;
					this.totalEntries = totalRows;
					this.creatorDetails = userDetails;
				}

				this.isGetInviteLoading = false;
			} catch (e) {
				const errMsg =
					e.response.data.errMsg.message ||
					"Error occured while fetching invite list";
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: errMsg
				});
				this.isGetInviteLoading = false;
			}
		}
	}
};
</script>

<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.text-red {
	color: red;
}
.ml-2 {
	margin-left: 8px;
}
.filter-width {
	width: 200px;
}
.headerText {
	font-weight: 700;
	color: #000 !important;
	font-size: 14px !important;
}
.refreshText {
	font-weight: 700;
	font-size: 14px;
	margin-top: 20px;
	text-align: center;
}
</style>
